import styles from "./Services.module.css";

import { SERVICES_LIST } from "../../utils/app-content";
import { SectionTitle } from "../../components/SectionTitle/SectionTitle";
import { ServiceItem } from "../../components/ServiceItem/ServiceItem";
import { Container } from "../../layout/Container/Container";
import { Section } from "../../layout/Section/Section";

export const Services = () => {
  return (
    <Section id="services">
      <SectionTitle title="Services" subtitle="The Services That I Provide" />
      <Container className={`${styles.service}`}>
        {SERVICES_LIST.map((service, idx) => (
          <ServiceItem
            key={idx}
            Icon={service.Icon}
            title={service.title}
            content={service.content}
          />
        ))}
      </Container>
    </Section>
  );
};
